/**
 * Initial state for the customercare module.
 *
 * @module store/modules/customercare/state
 */
import { CustomerCareState } from "./types";

const state: CustomerCareState = {
  dashboards: [],
  selectedTab: "dashboard",
  editorVisible: false,
};

export default state;
